import 'babel-polyfill';
import Vue from 'vue';
// import Vuetify from 'vuetify';
import VueGtag from 'vue-gtag';
import vuetify from '@/plugins/vuetify'
import router from './router';
import store from './store';
import App from './App.vue';
import printJS from 'print-js';
import './assets/css/main.css';
import VueSocialSharing from "vue-social-sharing";
import CKEditor from '@ckeditor/ckeditor5-vue';
import VueMask from 'v-mask'
import snackbarPlugin from '@/plugins/snackbar'
import '@/utils/downloadFile';
import '@/utils/setFilename';

// import 'vuetify/dist/vuetify.min.css';

// Vue.use(Vuetify);
Vue.use( CKEditor );
Vue.use(VueSocialSharing);
Vue.use(VueMask);
Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GA_MEASUREMENT_ID }
}, router);


Vue.use(snackbarPlugin, { store });

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  printJS,
  render: h => h(App),
}).$mount('#app');
